module.exports = __webpack_public_path__ + "img/afc_afcon_bracket_2023_bg.667344db.png";